import * as body from './body/body';
import * as toolbarAdministration from './toolbar-administration/toolbar-administration';
import * as contentHeader from './content-header/content-header';
import * as headings from './headings/headings';
import * as tabs from './tabs/tabs';
import * as breadcrumb from './breadcrumb/breadcrumb';
import * as blockShortcuts from './block-shortcuts/block-shortcuts';
import * as panel from './panel/panel';
import * as mediaLibraryView from './media-library-view/media-library-view';
import * as messages from './messages/messages';
import * as verticalTabs from './vertical-tabs/vertical-tabs';
import * as formApi from './form-api/form-api';

export default {
  body,
  toolbarAdministration,
  contentHeader,
  headings,
  tabs,
  breadcrumb,
  blockShortcuts,
  // panel,
  mediaLibraryView,
  messages,
  // verticalTabs,
  // formApi,
};
